import { jsx as _jsx } from "react/jsx-runtime";
import Grid from '@material-ui/core/Grid';
import { useFooterStyles } from "../useFooterStyles";
export const FooterGrid = (props) => {
    const classes = useFooterStyles();
    return (_jsx(Grid, { container: true, className: classes.Grid, ...props }, void 0));
};
//# sourceMappingURL=FooterGrid.js.map